// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__57vBN","resendInfoText":"OnGoingPaymentBox_resendInfoText__3uP0G"};